/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './content-writing.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '@angular/core/src/linker/view_utils';
import * as import5 from '@angular/core/src/di/injector';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/change_detection';
import * as import8 from '../shared/config.service';
import * as import9 from '../shared/intl.service';
import * as import10 from '@angular/core/src/linker/element_ref';
import * as import11 from '../shared/utils.service';
import * as import12 from '../shared/meta.service';
import * as import13 from '../shared/content.service';
import * as import14 from '@angular/router/src/router_state';
import * as import15 from '@angular/core/src/metadata/view';
import * as import16 from '@angular/core/src/linker/component_factory';
import * as import17 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import18 from '../shared/intl.pipe';
import * as import19 from '@angular/common/src/pipes/date_pipe';
import * as import20 from '@angular/core/src/linker/template_ref';
import * as import21 from '@angular/core/src/i18n/tokens';
import * as import22 from '@angular/common/src/directives/ng_if';
import * as import23 from '../shared/loading-indicator.ngfactory';
import * as import24 from '../shared/loading-indicator';
import * as import25 from '@angular/core/src/security';
export class Wrapper_ContentWritingComponent {
  context:import0.ContentWritingComponent;
  changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any) {
    this.changed = false;
    this.context = new import0.ContentWritingComponent(p0,p1,p2,p3,p4,p5,p6);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_ContentWritingComponent_Host:import2.RenderComponentType = (null as any);
class _View_ContentWritingComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _ContentWritingComponent_0_4:Wrapper_ContentWritingComponent;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingComponent_Host0,renderType_ContentWritingComponent_Host,import6.ViewType.HOST,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer,'ng-component',import4.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_ContentWritingComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._ContentWritingComponent_0_4 = new Wrapper_ContentWritingComponent(this.parentInjector.get(import8.ConfigService),this.parentInjector.get(import9.IntlService),new import10.ElementRef(this._el_0),this.parentInjector.get(import11.UtilsService),this.parentInjector.get(import12.MetaService),this.parentInjector.get(import13.ContentService),this.parentInjector.get(import14.ActivatedRoute));
    this._appEl_0.initComponent(this._ContentWritingComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._ContentWritingComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.ContentWritingComponent) && (0 === requestNodeIndex))) { return this._ContentWritingComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ContentWritingComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    if (!throwOnChange) { this._ContentWritingComponent_0_4.context.ngAfterContentChecked(); }
    this._ContentWritingComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentWritingComponent_Host0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_ContentWritingComponent_Host === (null as any))) { (renderType_ContentWritingComponent_Host = viewUtils.createRenderComponentType('',0,import15.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_ContentWritingComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const ContentWritingComponentNgFactory:import16.ComponentFactory<import0.ContentWritingComponent> = new import16.ComponentFactory<import0.ContentWritingComponent>('ng-component',viewFactory_ContentWritingComponent_Host0,import0.ContentWritingComponent);
const styles_ContentWritingComponent:any[] = ([] as any[]);
var renderType_ContentWritingComponent:import2.RenderComponentType = (null as any);
class _View_ContentWritingComponent0 extends import1.AppView<import0.ContentWritingComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _el_20:any;
  _text_21:any;
  _el_22:any;
  _el_23:any;
  _text_24:any;
  _text_25:any;
  _text_26:any;
  _text_27:any;
  _text_28:any;
  _text_29:any;
  _text_30:any;
  _text_31:any;
  _el_32:any;
  _text_33:any;
  _text_34:any;
  _anchor_35:any;
  /*private*/ _appEl_35:import3.AppElement;
  _TemplateRef_35_5:any;
  _NgIf_35_6:import17.Wrapper_NgIf;
  _text_36:any;
  _anchor_37:any;
  /*private*/ _appEl_37:import3.AppElement;
  _TemplateRef_37_5:any;
  _NgIf_37_6:import17.Wrapper_NgIf;
  _text_38:any;
  /*private*/ _expr_45:any;
  _pipe_intl_0:import18.IntlPipe;
  _pipe_intl_0_0:any;
  /*private*/ _expr_48:any;
  _pipe_intl_0_1:any;
  _pipe_date_1:import19.DatePipe;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingComponent0,renderType_ContentWritingComponent,import6.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_45 = import7.UNINITIALIZED;
    this._expr_48 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._el_0 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray2(2,'class','page-title-pull-top page-title parallax3 parallax-fix'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','opacity-light bg-dark-gray'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_4 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._text_5 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_6 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray2(2,'class','page-title page-title-small bg-gray'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n    ',(null as any));
    this._el_8 = import4.createRenderElement(this.renderer,this._el_6,'div',new import4.InlineArray2(2,'class','container'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n        ',(null as any));
    this._el_10 = import4.createRenderElement(this.renderer,this._el_8,'div',new import4.InlineArray2(2,'class','row'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n            ',(null as any));
    this._el_12 = import4.createRenderElement(this.renderer,this._el_10,'div',new import4.InlineArray2(2,'class','col-lg-4 col-md-5 col-sm-12'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                ',(null as any));
    this._el_14 = import4.createRenderElement(this.renderer,this._el_12,'h1',new import4.InlineArray2(2,'class','black-text'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'',(null as any));
    this._text_16 = this.renderer.createText(this._el_12,'\n            ',(null as any));
    this._text_17 = this.renderer.createText(this._el_10,'\n            ',(null as any));
    this._el_18 = import4.createRenderElement(this.renderer,this._el_10,'div',new import4.InlineArray2(2,'class','col-lg-8 col-md-7 col-sm-12 breadcrumb text-uppercase'),(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'\n                ',(null as any));
    this._el_20 = import4.createRenderElement(this.renderer,this._el_18,'ul',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_21 = this.renderer.createText(this._el_20,'\n                    ',(null as any));
    this._el_22 = import4.createRenderElement(this.renderer,this._el_20,'li',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._el_23 = import4.createRenderElement(this.renderer,this._el_22,'a',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'',(null as any));
    this._text_25 = this.renderer.createText(this._el_20,'\n                ',(null as any));
    this._text_26 = this.renderer.createText(this._el_18,'\n            ',(null as any));
    this._text_27 = this.renderer.createText(this._el_10,'\n        ',(null as any));
    this._text_28 = this.renderer.createText(this._el_8,'\n    ',(null as any));
    this._text_29 = this.renderer.createText(this._el_6,'\n',(null as any));
    this._text_30 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._text_31 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_32 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray2(2,'class','blog-single-full-width-text'),(null as any));
    this._text_33 = this.renderer.createText(this._el_32,'\n    ',(null as any));
    this._text_34 = this.renderer.createText(this._el_32,'\n    ',(null as any));
    this._anchor_35 = this.renderer.createTemplateAnchor(this._el_32,(null as any));
    this._appEl_35 = new import3.AppElement(35,32,this,this._anchor_35);
    this._TemplateRef_35_5 = new import20.TemplateRef_(this._appEl_35,viewFactory_ContentWritingComponent1);
    this._NgIf_35_6 = new import17.Wrapper_NgIf(this._appEl_35.vcRef,this._TemplateRef_35_5);
    this._text_36 = this.renderer.createText(this._el_32,'\n    ',(null as any));
    this._anchor_37 = this.renderer.createTemplateAnchor(this._el_32,(null as any));
    this._appEl_37 = new import3.AppElement(37,32,this,this._anchor_37);
    this._TemplateRef_37_5 = new import20.TemplateRef_(this._appEl_37,viewFactory_ContentWritingComponent2);
    this._NgIf_37_6 = new import17.Wrapper_NgIf(this._appEl_37.vcRef,this._TemplateRef_37_5);
    this._text_38 = this.renderer.createText(this._el_32,'\n',(null as any));
    this._pipe_intl_0 = new import18.IntlPipe();
    this._pipe_intl_0_0 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    var disposable_0:Function = this.renderer.listen(this._el_23,'click',this.eventHandler(this._handle_click_23_0.bind(this)));
    this._pipe_intl_0_1 = import4.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    this._pipe_date_1 = new import19.DatePipe(this.parentInjector.get(import21.LOCALE_ID));
    this.init(([] as any[]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._el_20,
      this._text_21,
      this._el_22,
      this._el_23,
      this._text_24,
      this._text_25,
      this._text_26,
      this._text_27,
      this._text_28,
      this._text_29,
      this._text_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._text_34,
      this._anchor_35,
      this._text_36,
      this._anchor_37,
      this._text_38
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import20.TemplateRef) && (35 === requestNodeIndex))) { return this._TemplateRef_35_5; }
    if (((token === import22.NgIf) && (35 === requestNodeIndex))) { return this._NgIf_35_6.context; }
    if (((token === import20.TemplateRef) && (37 === requestNodeIndex))) { return this._TemplateRef_37_5; }
    if (((token === import22.NgIf) && (37 === requestNodeIndex))) { return this._NgIf_37_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    const currVal_35_0_0:any = this.context.loading;
    this._NgIf_35_6.check_ngIf(currVal_35_0_0,throwOnChange,false);
    this._NgIf_35_6.detectChangesInInputProps(this,this._anchor_35,throwOnChange);
    const currVal_37_0_0:any = (this.context.content && this.context.currentLanguage);
    this._NgIf_37_6.check_ngIf(currVal_37_0_0,throwOnChange,false);
    this._NgIf_37_6.detectChangesInInputProps(this,this._anchor_37,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_45:any = import4.interpolate(1,'\n                ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_0,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.COMMON.MENU.WRITINGS.LONG),this.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_45,currVal_45))) {
      this.renderer.setText(this._text_15,currVal_45);
      this._expr_45 = currVal_45;
    }
    valUnwrapper.reset();
    const currVal_48:any = import4.interpolate(1,'\n                    ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_1,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.COMMON.MENU.WRITINGS.ALL),this.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_48,currVal_48))) {
      this.renderer.setText(this._text_24,currVal_48);
      this._expr_48 = currVal_48;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_23_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_23_0:any = ((<any>this.context.utils.lLink('writings',this.context.currentLanguage)) !== false);
    return (true && pd_23_0);
  }
}
export function viewFactory_ContentWritingComponent0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<import0.ContentWritingComponent> {
  if ((renderType_ContentWritingComponent === (null as any))) { (renderType_ContentWritingComponent = viewUtils.createRenderComponentType('',0,import15.ViewEncapsulation.None,styles_ContentWritingComponent,{})); }
  return new _View_ContentWritingComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  /*private*/ _appEl_4:import3.AppElement;
  _LoadingIndicator_4_4:import23.Wrapper_LoadingIndicator;
  _text_5:any;
  _text_6:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingComponent1,renderType_ContentWritingComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','container'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','row'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_2,'loading-indicator',new import4.InlineArray2(2,'color','#B6B6B6'),(null as any));
    this._appEl_4 = new import3.AppElement(4,2,this,this._el_4);
    var compView_4:any = import23.viewFactory_LoadingIndicator0(this.viewUtils,this.injector(4),this._appEl_4);
    this._LoadingIndicator_4_4 = new import23.Wrapper_LoadingIndicator();
    this._appEl_4.initComponent(this._LoadingIndicator_4_4.context,([] as any[]),compView_4);
    compView_4.create(this._LoadingIndicator_4_4.context,([] as any[]),(null as any));
    this._text_5 = this.renderer.createText(this._el_2,'  \n        ',(null as any));
    this._text_6 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import24.LoadingIndicator) && (4 === requestNodeIndex))) { return this._LoadingIndicator_4_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_4_0_0:any = '#B6B6B6';
    this._LoadingIndicator_4_4.check_color(currVal_4_0_0,throwOnChange,false);
    this._LoadingIndicator_4_4.detectChangesInInputProps(this,this._el_4,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._LoadingIndicator_4_4.detectChangesInHostProps(this,this._el_4,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentWritingComponent1(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  _el_8:any;
  _el_9:any;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  _anchor_17:any;
  /*private*/ _appEl_17:import3.AppElement;
  _TemplateRef_17_5:any;
  _NgIf_17_6:import17.Wrapper_NgIf;
  _text_18:any;
  _anchor_19:any;
  /*private*/ _appEl_19:import3.AppElement;
  _TemplateRef_19_5:any;
  _NgIf_19_6:import17.Wrapper_NgIf;
  _text_20:any;
  /*private*/ _expr_27:any;
  /*private*/ _expr_28:any;
  _pipe_intl_0_2:any;
  /*private*/ _expr_30:any;
  /*private*/ _expr_31:any;
  _pipe_date_1_0:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingComponent2,renderType_ContentWritingComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_27 = import7.UNINITIALIZED;
    this._expr_28 = import7.UNINITIALIZED;
    this._expr_30 = import7.UNINITIALIZED;
    this._expr_31 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','container writing-content'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._text_2 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._el_3 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','row writing-header col-md-10 col-sm-10 col-xs-11 text-center center-col'),(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'\n            ',(null as any));
    this._el_5 = import4.createRenderElement(this.renderer,this._el_3,'h2',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_6 = this.renderer.createText(this._el_5,'',(null as any));
    this._text_7 = this.renderer.createText(this._el_3,'\n            ',(null as any));
    this._el_8 = import4.createRenderElement(this.renderer,this._el_3,'h4',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._el_9 = import4.createRenderElement(this.renderer,this._el_8,'small',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'',(null as any));
    this._text_11 = this.renderer.createText(this._el_8,'',(null as any));
    this._el_12 = import4.createRenderElement(this.renderer,this._el_8,'small',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_3,'\n        ',(null as any));
    this._text_15 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._text_16 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._anchor_17 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_17 = new import3.AppElement(17,0,this,this._anchor_17);
    this._TemplateRef_17_5 = new import20.TemplateRef_(this._appEl_17,viewFactory_ContentWritingComponent3);
    this._NgIf_17_6 = new import17.Wrapper_NgIf(this._appEl_17.vcRef,this._TemplateRef_17_5);
    this._text_18 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._anchor_19 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_19 = new import3.AppElement(19,0,this,this._anchor_19);
    this._TemplateRef_19_5 = new import20.TemplateRef_(this._appEl_19,viewFactory_ContentWritingComponent4);
    this._NgIf_19_6 = new import17.Wrapper_NgIf(this._appEl_19.vcRef,this._TemplateRef_19_5);
    this._text_20 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._pipe_intl_0_2 = import4.pureProxy2((<_View_ContentWritingComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_ContentWritingComponent0>this.parent)._pipe_intl_0));
    this._pipe_date_1_0 = import4.pureProxy2((<_View_ContentWritingComponent0>this.parent)._pipe_date_1.transform.bind((<_View_ContentWritingComponent0>this.parent)._pipe_date_1));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7,
      this._el_8,
      this._el_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._text_16,
      this._anchor_17,
      this._text_18,
      this._anchor_19,
      this._text_20
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import20.TemplateRef) && (17 === requestNodeIndex))) { return this._TemplateRef_17_5; }
    if (((token === import22.NgIf) && (17 === requestNodeIndex))) { return this._NgIf_17_6.context; }
    if (((token === import20.TemplateRef) && (19 === requestNodeIndex))) { return this._TemplateRef_19_5; }
    if (((token === import22.NgIf) && (19 === requestNodeIndex))) { return this._NgIf_19_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    const currVal_17_0_0:any = this.parent.context.content.content[this.parent.context.currentLanguage];
    this._NgIf_17_6.check_ngIf(currVal_17_0_0,throwOnChange,false);
    this._NgIf_17_6.detectChangesInInputProps(this,this._anchor_17,throwOnChange);
    const currVal_19_0_0:boolean = !this.parent.context.content.content[this.parent.context.currentLanguage];
    this._NgIf_19_6.check_ngIf(currVal_19_0_0,throwOnChange,false);
    this._NgIf_19_6.detectChangesInInputProps(this,this._anchor_19,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_27:any = import4.interpolate(1,'',this.parent.context.content.title[this.parent.context.currentLanguage],'');
    if (import4.checkBinding(throwOnChange,this._expr_27,currVal_27)) {
      this.renderer.setText(this._text_6,currVal_27);
      this._expr_27 = currVal_27;
    }
    valUnwrapper.reset();
    const currVal_28:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_2,(<_View_ContentWritingComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.WRITING.AUTHOR_BY),this.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_28,currVal_28))) {
      this.renderer.setText(this._text_10,currVal_28);
      this._expr_28 = currVal_28;
    }
    const currVal_30:any = import4.interpolate(1,' ',this.parent.context.content.author,', ');
    if (import4.checkBinding(throwOnChange,this._expr_30,currVal_30)) {
      this.renderer.setText(this._text_11,currVal_30);
      this._expr_30 = currVal_30;
    }
    valUnwrapper.reset();
    const currVal_31:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_date_1_0,(<_View_ContentWritingComponent0>this.parent)._pipe_date_1.transform)(this.parent.context.content.date,'yyyy')),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_31,currVal_31))) {
      this.renderer.setText(this._text_13,currVal_31);
      this._expr_31 = currVal_31;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentWritingComponent2(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingComponent3,renderType_ContentWritingComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_2 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',new import4.InlineArray2(2,'class','row col-md-10 col-sm-10 col-xs-11 center-col'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_2:any = this.parent.parent.context.content.content[this.parent.parent.context.currentLanguage];
    if (import4.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setElementProperty(this._el_0,'innerHTML',this.viewUtils.sanitizer.sanitize(import25.SecurityContext.HTML,currVal_2));
      this._expr_2 = currVal_2;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentWritingComponent3(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingComponent3(viewUtils,parentInjector,declarationEl);
}
class _View_ContentWritingComponent4 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _el_7:any;
  _text_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  /*private*/ _expr_17:any;
  /*private*/ _expr_18:any;
  _pipe_intl_0_3:any;
  /*private*/ _expr_20:any;
  _pipe_intl_0_4:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentWritingComponent4,renderType_ContentWritingComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_17 = import7.UNINITIALIZED;
    this._expr_18 = import7.UNINITIALIZED;
    this._expr_20 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'div',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'div',new import4.InlineArray2(2,'class','writing-body'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','row col-md-10 col-sm-10 col-xs-11 center-col'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                ',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_7 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','writing-not-translated'),(null as any));
    this._text_8 = this.renderer.createText(this._el_7,'',(null as any));
    this._text_9 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_10 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','writing-read-preferred row col-md-12 col-sm-12 center-col text-center'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                    ',(null as any));
    this._el_12 = import4.createRenderElement(this.renderer,this._el_10,'a',new import4.InlineArray2(2,'class','pointer highlight-button btn btn-small button xs-margin-bottom-five'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_10,'\n                ',(null as any));
    this._text_15 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._text_16 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._pipe_intl_0_3 = import4.pureProxy2((<_View_ContentWritingComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_ContentWritingComponent0>this.parent.parent)._pipe_intl_0));
    var disposable_0:Function = this.renderer.listen(this._el_12,'click',this.eventHandler(this._handle_click_12_0.bind(this)));
    this._pipe_intl_0_4 = import4.pureProxy2((<_View_ContentWritingComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_ContentWritingComponent0>this.parent.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._el_7,
      this._text_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._text_16
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_17:any = this.parent.parent.context.content.summary[this.parent.parent.context.currentLanguage];
    if (import4.checkBinding(throwOnChange,this._expr_17,currVal_17)) {
      this.renderer.setElementProperty(this._el_4,'innerHTML',this.viewUtils.sanitizer.sanitize(import25.SecurityContext.HTML,currVal_17));
      this._expr_17 = currVal_17;
    }
    valUnwrapper.reset();
    const currVal_18:any = import4.interpolate(1,'\n                    ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_3,(<_View_ContentWritingComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.WRITING.NOT_TRANSLATED),this.parent.parent.context.currentLanguage)),'\n                ');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_18,currVal_18))) {
      this.renderer.setText(this._text_8,currVal_18);
      this._expr_18 = currVal_18;
    }
    valUnwrapper.reset();
    const currVal_20:any = import4.interpolate(1,'\n                    ',valUnwrapper.unwrap(import4.castByValue(this._pipe_intl_0_4,(<_View_ContentWritingComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.WRITING.READ_IN_PREFERRED_LANGUAGE),this.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_20,currVal_20))) {
      this.renderer.setText(this._text_13,currVal_20);
      this._expr_20 = currVal_20;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_12_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_12_0:any = ((<any>this.parent.parent.context.utils.lLink(((this.parent.parent.context.type + '/') + this.parent.parent.context.content.url),((this.parent.parent.context.writingConfig.data == (null as any))? (null as any): this.parent.parent.context.writingConfig.data.APP.LANGUAGES.PREFERRED))) !== false);
    return (true && pd_12_0);
  }
}
function viewFactory_ContentWritingComponent4(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentWritingComponent4(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/content-writing.component.ngfactory.ts